import { render, staticRenderFns } from "./Institutes.vue?vue&type=template&id=6b1e0f14&scoped=true&"
import script from "./Institutes.vue?vue&type=script&lang=js&"
export * from "./Institutes.vue?vue&type=script&lang=js&"
import style0 from "./Institutes.vue?vue&type=style&index=0&id=6b1e0f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e0f14",
  null
  
)

export default component.exports